import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/app-skeleton';
import { cn } from '@/lib/ui/utils';
import { RIGHT_COLUMN_CARD_RESTING_SHELL } from './right-column-card-chrome';

// Resting-state skeleton for the Biggest-Prize-Pools card. Used both by the
// route-level RightColumnSkeleton and by TopMarketsByPrizeWidget itself while
// its prize-pool query is pending, so the skeleton → content hand-off is
// seamless (no late pop).
export function PrizePoolsCardSkeleton(t0) {
  const $ = _c(6);
  const {
    testId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(RIGHT_COLUMN_CARD_RESTING_SHELL, "flex min-h-0 flex-1 flex-col gap-3");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-4 w-36" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-between">{t2}<div className="flex items-center gap-1.5"><Skeleton className="h-1.5 w-6 rounded-full" /><Skeleton className="size-1.5 rounded-full" /><Skeleton className="size-1.5 rounded-full" /></div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mt-auto flex flex-col gap-2"><Skeleton className="h-8 w-[40%]" /><Skeleton className="h-4 w-[85%]" /><Skeleton className="h-4 w-[65%]" /></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== testId) {
    t5 = <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden" data-testid="top-markets-by-prize-carousel-skeleton"><div className={t1} data-testid={testId}>{t3}{t4}</div></div>;
    $[4] = testId;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}